export const assembleDataStructure = function (dataElement){
    return {
        dataElementProperty:dataElement,
        dataId:dataElement.element_type,
        dataElementThreeObject:null,
    }
}
